import { render, staticRenderFns } from "./AuthorizeBooking.vue?vue&type=template&id=2fdd67aa&"
import script from "./AuthorizeBooking.vue?vue&type=script&lang=js&"
export * from "./AuthorizeBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports